/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/SvgIcon/index.vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-69e4db34"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "后台管理中心", -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-login-footer"
}, [/*#__PURE__*/_createElementVNode("span", null, "©2022-2023 瑶光平台 版权所有 京ICP备2023001502号-1")], -1));
import { getCodeImg } from "@/api/login";
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import useUserStore from '@/store/modules/user';
export default {
  __name: 'login',
  setup(__props) {
    const userStore = useUserStore();
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const loginForm = ref({
      accountName: "xc",
      pwd: "123456",
      rememberMe: false,
      code: "",
      uuid: ""
    });
    const loginRules = {
      accountName: [{
        required: true,
        trigger: "blur",
        message: "请输入您的账号"
      }],
      pwd: [{
        required: true,
        trigger: "blur",
        message: "请输入您的密码"
      }]
      // code: [{ required: true, trigger: "change", message: "请输入验证码" }]
    };

    const codeUrl = ref("");
    const loading = ref(false);
    // 验证码开关
    const captchaOnOff = ref(true);
    // 注册开关
    const register = ref(false);
    const redirect = ref(undefined);
    const testData = ref([]);
    function handleLogin() {
      proxy.$refs.loginRef.validate(valid => {
        if (valid) {
          loading.value = true;
          // 勾选了需要记住密码设置在 cookie 中设置记住用户名和密码
          if (loginForm.value.rememberMe) {
            Cookies.set("username", loginForm.value.accountName, {
              expires: 30
            });
            Cookies.set("password", encrypt(loginForm.value.pwd), {
              expires: 30
            });
            Cookies.set("rememberMe", loginForm.value.rememberMe, {
              expires: 30
            });
          } else {
            // 否则移除
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          // 调用action的登录方法
          userStore.login(loginForm.value).then(() => {
            // router.push({ path: redirect.value || "/" });
            router.push({
              path: "/sms/smsManagement"
            });
          }).catch(() => {
            loading.value = false;
            // 重新获取验证码
            if (captchaOnOff.value) {
              // getCode();
            }
          });
        }
      });
    }
    function getCode() {
      getCodeImg().then(res => {
        captchaOnOff.value = res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (captchaOnOff.value) {
          codeUrl.value = "data:image/gif;base64," + res.img;
          loginForm.value.uuid = res.uuid;
        }
      });
    }
    function getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      loginForm.value = {
        accountName: username === undefined ? loginForm.value.accountName : username,
        pwd: password === undefined ? loginForm.value.pwd : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    }

    // getCode();
    getCookie();
    return (_ctx, _cache) => {
      const _component_svg_icon = __unplugin_components_0;
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref: "loginRef",
        model: _unref(loginForm),
        rules: loginRules,
        class: "login-form"
      }, {
        default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_form_item, {
          prop: "accountName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).accountName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(loginForm).accountName = $event),
            type: "text",
            size: "large",
            "auto-complete": "off",
            placeholder: "账号"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "user",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "pwd"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(loginForm).pwd,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(loginForm).pwd = $event),
            type: "password",
            size: "large",
            "auto-complete": "off",
            placeholder: "密码",
            onKeyup: _withKeys(handleLogin, ["enter"])
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              "icon-class": "password",
              class: "el-input__icon input-icon"
            })]),
            _: 1
          }, 8, ["modelValue", "onKeyup"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: _unref(loading),
            size: "large",
            type: "primary",
            style: {
              "width": "100%"
            },
            onClick: _withModifiers(handleLogin, ["prevent"])
          }, {
            default: _withCtx(() => [!_unref(loading) ? (_openBlock(), _createElementBlock("span", _hoisted_3, "登 录")) : (_openBlock(), _createElementBlock("span", _hoisted_4, "登 录 中..."))]),
            _: 1
          }, 8, ["loading", "onClick"]), _unref(register) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_router_link, {
            class: "link-type",
            to: '/register'
          }, {
            default: _withCtx(() => [_createTextVNode("立即注册")]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _hoisted_6]);
    };
  }
};